/**
 * Stable id helper that links a dot (tab) to its slide (tabpanel) for ARIA.
 *
 * The single source of truth for the tab id convention so that
 * server-rendered slides and the client-side dots agree without each side
 * re-deriving the string template. Custom, portal-specific slide markup can
 * import this to stay wired to the shared controls.
 */
export const getTabId = (idx: number): string => `hero-carousel-tab-${idx + 1}`;
